// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607231154/js/" + chunkId + "." + {"44":"367872d5","225":"b247d250","481":"59d66cd4","486":"902508bd","770":"c4a1c0af"}[chunkId] + ".0.06545424152291246.chunk.js";
};